export default __webpack_public_path__ + "static/media/closeRed.12007f3a.svg";